var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar bg-neutral-600",
    class: {
      'shrink-menu': !_vm.sidebarStatus
    }
  }, [_c('div', {
    staticClass: "pt-5"
  }, [_c('div', {
    staticClass: "flex flex-col px-4 mb-10",
    class: [!_vm.sidebarStatus ? 'items-start' : 'items-center']
  }, [_c('router-link', {
    staticClass: "h-8 flex items-center",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "w-32",
    attrs: {
      "src": _vm.logoState()
    }
  })])], 1), _vm._l(_vm.menuList, function (menu, index) {
    return _c('div', {
      key: index
    }, [!menu.submenu ? _c('router-link', {
      staticClass: "flex px-4 py-3 gap-4 items-center transition-all ease-linear duration-200 hover:text-primary-500",
      class: {
        'active-link': _vm.activePath === menu.url
      },
      attrs: {
        "to": menu.url
      }
    }, [_c('span', {
      staticClass: "inline-block flex-shrink-0"
    }, [_c(menu.icon, {
      tag: "component",
      attrs: {
        "width": "20",
        "height": "20"
      }
    })], 1), _c('transition', {
      attrs: {
        "name": "fade",
        "duration": 100
      }
    }, [_vm.sidebarStatus ? _c('div', {
      staticClass: "font-medium title whitespace-nowrap text-sm"
    }, [_vm._v(_vm._s(menu.title))]) : _vm._e()])], 1) : _c('div', {
      staticClass: "gap-4 justify-between items-start"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: menu.active,
        expression: "menu.active"
      }],
      attrs: {
        "type": "checkbox",
        "id": "checkbox-".concat(index)
      },
      domProps: {
        "checked": Array.isArray(menu.active) ? _vm._i(menu.active, null) > -1 : menu.active
      },
      on: {
        "change": function change($event) {
          var $$a = menu.active,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = null,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(menu, "active", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(menu, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(menu, "active", $$c);
          }
        }
      }
    }), _c('label', {
      staticClass: "font-medium py-3 px-4 flex gap-4 items-center justify-between cursor-pointer transition-all duration-200 hover:text-primary-500",
      attrs: {
        "for": "checkbox-".concat(index)
      }
    }, [_c('div', {
      staticClass: "flex gap-4 items-center justify-start"
    }, [_c('span', {
      staticClass: "inline-block flex-shrink-0"
    }, [_c(menu.icon, {
      tag: "component",
      attrs: {
        "width": "24",
        "height": "24"
      }
    })], 1), _c('transition', {
      attrs: {
        "name": "fade",
        "duration": 100
      }
    }, [_vm.sidebarStatus ? _c('p', {
      staticClass: "font-medium title whitespace-nowrap "
    }, [_vm._v(_vm._s(menu.title))]) : _vm._e()])], 1), _vm.sidebarStatus ? _c('Chevron', {
      attrs: {
        "color": "white",
        "width": "12",
        "height": "12",
        "direction": menu.active ? 'up' : 'down'
      }
    }) : _vm._e()], 1), _c('div', {
      staticClass: "submenu bg-neutral-600",
      class: {
        active: menu.active
      }
    }, _vm._l(menu.submenu, function (submenu, idx) {
      return _c('router-link', {
        key: idx,
        staticClass: "flex px-4 py-2 gap-4 items-center transition-all duration-200 hover:text-primary-500",
        class: {
          'active-link': _vm.activePath === submenu.url
        },
        attrs: {
          "to": submenu.url
        }
      }, [_c('div', {
        staticClass: "font-medium"
      }, [_vm._v(_vm._s(submenu.title))])]);
    }), 1)])], 1);
  })], 2), _vm.sidebarStatus ? _c('div', {
    staticClass: "absolute bottom-8 w-full px-4 flex justify-center select-none"
  }, [_vm._m(0)]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex items-center justify-center gap-2 w-full max-w-[150px] py-1.5 bg-white border border-neutral-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 cursor-default"
  }, [_c('span', {
    staticClass: "text-sm font-medium text-neutral-500 ml-2"
  }, [_vm._v(" Powered by ")]), _c('img', {
    staticClass: "h-6",
    attrs: {
      "src": require("@/assets/images/logos/linknau-w-tag.png"),
      "alt": "Linknau"
    }
  })]);
}]

export { render, staticRenderFns }